import { AudioConstraints, FileMessages } from './types';

export const AUDIO_CONSTRAINTS: AudioConstraints = {
  DURATION: {
    MIN: 5 * 1000,
    MAX: 15 * 60 * 1000,
  },
  SIZE: {
    MAX: 10 * 1024 * 1024,
  },
};

export const FILE_MESSAGES: FileMessages = {
  DURATION_MIN: 'The audio duration min 5 second',
  DURATION_MAX: 'The audio duration max 5 mins',
  INVALID_FILE_TYPE: 'The file type is not supported',
  INVALID_FILE_FORMAT: 'The file format is not supported',
  SIZE_MAX: (size: number) => `The audio size must less than ${size}mb`,
  UPLOAD_SUCCESS: {
    TITLE: 'File uploaded successfully',
    DESCRIPTION: 'Select instrument or enter a prompt to jenerate.',
  },
};
